// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { CashRegisterConfigurablePaymentFragment } from '../../fragments/generated/cash-register-configurable-payment.fragment.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetCashRegisterConfigurablePaymentsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCashRegisterConfigurablePaymentsQueryResult = { __typename?: 'Query', getCashRegisterConfigurablePayments: Array<{ __typename?: 'CashRegisterConfigurablePaymentDTO', type: Types.CashRegisterPaymentTypeEnumDto, description: string } | null> | null };

export const GetCashRegisterConfigurablePaymentsGql = gql`
    query GetCashRegisterConfigurablePayments {
  getCashRegisterConfigurablePayments {
    ...CashRegisterConfigurablePayment
  }
}
    ${CashRegisterConfigurablePaymentFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCashRegisterConfigurablePaymentsInjectable extends Apollo.Query<GetCashRegisterConfigurablePaymentsQueryResult, GetCashRegisterConfigurablePaymentsQueryVariables> {
    override document = GetCashRegisterConfigurablePaymentsGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */